(function () {
  'use strict';
  if (window.familoCartInitialized) return;
  window.familoCartInitialized = true;

  const config = window.FamiloCartSettings || {};
  let revision = 0, syncTimer = null, inFlight = false, needsRefresh = false;
  let cartRoot = null, cartObserver = null, discoveryObserver = null, formatQueued = false;
  const hiddenUpsells = new WeakMap();
  let lastCount = countFrom({ item_count: config.initialCount });

  function countFrom(cart) {
    if (!cart || cart.item_count === null || cart.item_count === undefined) return null;
    const count = Number(cart.item_count);
    return Number.isInteger(count) && count >= 0 ? count : null;
  }

  function renderCount(count) {
    lastCount = count;
    const icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    let bubble = icon.querySelector('.cart-count-bubble');
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      const number = document.createElement('span');
      number.setAttribute('aria-hidden', 'true');
      const hidden = document.createElement('span');
      hidden.className = 'visually-hidden';
      bubble.append(number, hidden);
      icon.appendChild(bubble);
    }
    const number = bubble.querySelector('[aria-hidden="true"]');
    const hidden = bubble.querySelector('.visually-hidden');
    const visibleText = count < 100 ? String(count) : '';
    const accessibleText = count ? count + ' prekės krepšelyje' : 'Krepšelis tuščias';
    if (number && number.textContent !== visibleText) number.textContent = visibleText;
    if (hidden && hidden.textContent !== accessibleText) hidden.textContent = accessibleText;
  }

  function scheduleSync() {
    if (syncTimer !== null) clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      syncTimer = null;
      if (inFlight) { needsRefresh = true; return; }
      fetchCount();
    }, 150);
  }

  async function fetchCount() {
    inFlight = true;
    needsRefresh = false;
    const requestedRevision = revision;
    try {
      const base = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      const response = await fetch(base + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Cart request failed');
      const count = countFrom(await response.json());
      if (count !== null && requestedRevision === revision) renderCount(count);
    } catch (error) {
      // Keep the existing count when an optional header refresh fails.
    } finally {
      inFlight = false;
      if (needsRefresh) scheduleSync();
    }
  }

  function cartUpdated(cart) {
    revision++;
    const count = countFrom(cart);
    if (count !== null) {
      if (syncTimer !== null) clearTimeout(syncTimer);
      syncTimer = null;
      needsRefresh = false;
      renderCount(count);
    } else {
      scheduleSync();
    }
    bindCartRoot();
    queueFormat();
  }

  function formatCart() {
    formatQueued = false;
    if (!cartRoot || !cartRoot.isConnected) return;
    cartRoot.querySelectorAll('[data-testid="AupsellTitle"]').forEach(function (title) {
      const words = title.textContent.trim().split(/\s+/);
      if (words.length > 5) title.textContent = words.slice(0, 5).join(' ') + '…';
    });
    cartRoot.querySelectorAll('.upsells-stacked-container').forEach(function (container) {
      const track = container.querySelector('.slick-track');
      if (!track) return;
      if (track.children.length === 0) {
        if (!hiddenUpsells.has(container)) hiddenUpsells.set(container, container.style.display);
        if (container.style.display !== 'none') container.style.display = 'none';
      } else if (hiddenUpsells.has(container)) {
        container.style.display = hiddenUpsells.get(container);
        hiddenUpsells.delete(container);
      }
    });
    const walker = document.createTreeWalker(cartRoot, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const parent = node.parentElement;
      if (!parent || /^(SCRIPT|STYLE|TEXTAREA)$/.test(parent.tagName)) continue;
      if (node.nodeValue.trim() === 'FREE') node.nodeValue = node.nodeValue.replace('FREE', 'NEMOKAMAI');
    }
  }

  function queueFormat() {
    if (formatQueued || !cartRoot) return;
    formatQueued = true;
    queueMicrotask(formatCart);
  }

  function bindCartRoot() {
    const root = document.getElementById('slidecarthq') || document.querySelector('.slidecarthq');
    if (!root || root === cartRoot) return;
    if (cartObserver) cartObserver.disconnect();
    cartRoot = root;
    cartObserver = new MutationObserver(queueFormat);
    cartObserver.observe(root, { childList: true, subtree: true, characterData: true });
    if (discoveryObserver) { discoveryObserver.disconnect(); discoveryObserver = null; }
    queueFormat();
  }

  function hook(name) {
    const previous = window[name];
    window[name] = function (cart) {
      try {
        if (typeof previous === 'function') return previous.apply(this, arguments);
      } finally {
        cartUpdated(cart);
      }
    };
  }

  hook('SLIDECART_LOADED');
  hook('SLIDECART_UPDATED');

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) { cartUpdated(event && event.cartData); });
  }

  function start() {
    if (lastCount !== null) renderCount(lastCount);
    bindCartRoot();
    if (!cartRoot && document.body) {
      discoveryObserver = new MutationObserver(bindCartRoot);
      discoveryObserver.observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
